<template>
	<div class="tq-version-tag-box">
		<div v-if="closeable" class="absolute tag-box_closeable" @click="closeBox">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" data-v-ea893728="">
				<path fill="currentColor"
					d="M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 393.664L407.936 353.6a38.4 38.4 0 1 0-54.336 54.336L457.664 512 353.6 616.064a38.4 38.4 0 1 0 54.336 54.336L512 566.336 616.064 670.4a38.4 38.4 0 1 0 54.336-54.336L566.336 512 670.4 407.936a38.4 38.4 0 1 0-54.336-54.336z" />
			</svg>
			<!-- <i class="el-icon-error" /> -->
		</div>
		<div>
			<slot />
		</div>
	</div>
</template>

<script lang="ts">
import { computed } from 'vue'
export default {
	name: "TqVersionTagBox",
	props: {
		theme: {
			type: String,
			default: "yellow"
		},
		closeable: {
			type: Boolean,
			default: false
		}
	},
	emits: ['close'],
	setup(props, { emit }) {
		const closeBox = (e:any) => {
			emit("close", e)
		}

		const colorVariant = computed(() => {
			const map:any = {
				yellow: "border-yellow-400 bg-yellow-100",
				gray: "border-gray-400 bg-gray-100"
			}
			return map[props.theme]
		})

		return {
			closeBox,
			colorVariant
		}
	}
}
</script>